import {Component, computed, input, output} from '@angular/core';
import {IOrderHistoryView, IOrderHistoryViewProduct, IOrderHistoryViewProductDisplayAttribute} from '../orders-models';

@Component({
    selector: 'order-history-product-row',
    templateUrl: './order-history-product-row.component.html',
    styleUrls: ['../orders.scss', './order-history-product-row.component.scss'],
    standalone: false
})
export class OrderHistoryProductRowComponent {
    readonly orderView = input<IOrderHistoryView>();
    readonly displayAttributes = input<IOrderHistoryViewProductDisplayAttribute[]>([]);
    readonly displayVolume = input<boolean>(false);
    readonly headerLabels = input<string[]>([]);
    readonly itemAdded = output<IOrderHistoryViewProduct>();

    readonly hasProducts = computed(() => !!this.orderView()?.products?.length);

    // volume columns are dropped for users that do not display volume
    readonly visibleDisplayAttributes = computed(() => this.displayVolume()
        ? this.displayAttributes()
        : this.displayAttributes().filter((displayAttribute: IOrderHistoryViewProductDisplayAttribute) =>
            displayAttribute.name !== 'totalVolume' && displayAttribute.name !== 'volume'));

    readonly visibleHeaderLabels = computed(() => this.displayVolume()
        ? this.headerLabels()
        : this.headerLabels().filter((label: string) =>
            label !== 'cart.order.history.product.volume' && label !== 'cart.order.history.order.total.volume'));
}
